import React from "react";
import authFetch from "../authFetch";
function AuthImg({ src, alt, style, className }) {
  const [blobSrc, setBlobSrc] = React.useState("");
  React.useEffect(() => {
    if (!src) return;
    if (!src.startsWith("/api/file")) { setBlobSrc(src); return; }
    let revoked = false;
    authFetch(src).then(r => r.ok ? r.blob() : null).then(blob => {
      if (blob && !revoked) setBlobSrc(URL.createObjectURL(blob));
    }).catch(() => {});
    return () => { revoked = true; };
  }, [src]);
  if (!blobSrc) return null;
  return <img src={blobSrc} alt={alt||""} style={style} className={className}/>;
}
export default AuthImg;
